import styles from "./profile-reset-password.module.scss";
import { ReactComponent as LockKeyHole } from "assets/images/v2/lock-keyhole.svg";
import { ReactComponent as ChevronRight } from "assets/images/v2/chevron-right.svg";
import { PROFILE_RESET_PASSWORD_LABEL, PROFILE_RESET_PASSWORD_SUBTITLE } from "utilities/Constant";

export default function ProfileResetPassword() {
  return (
    <div className={styles.profileResetPasswordWrapper}>
      <div className={styles.profileResetPasswordCard}>
        <div className={styles.profileResetPasswordTitle}>
          <LockKeyHole className="icon" />
          <span>{PROFILE_RESET_PASSWORD_LABEL}</span>
        </div>
        <div className={styles.profileResetPasswordInfo}>
          <p className="nav-subtitle">{PROFILE_RESET_PASSWORD_SUBTITLE}</p>
          <ChevronRight className={styles.profileResetPasswordIcon} />
        </div>
      </div>
    </div>
  );
}
